<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("_SALE_PACKAGE.RATE_CATEGORY") }} - {{ $t('CHAIN') }}</h4>
      <v-btn color="primary" @click="addNew">
        <v-icon dark> mdi-plus </v-icon>
        {{ $t("_SALE_PACKAGE.RATE_CATEGORY_ADD_NEW") }}
      </v-btn>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('ENTER_NAME_OR_CODE')" v-on:keyup="getAll(1)"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group v-model="status" row class="mt-0" @change="getAll(1)">
            <v-radio :label="$t('ALL')" value="all"></v-radio>
            <v-radio :label="$t('ACTIVE')" value="1"></v-radio>
            <v-radio :label="$t('DEACTIVE')" value="0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <loading :active.sync="isLoadingPopup" :is-full-page="false"></loading>
      <v-simple-table fixed-header height="calc(100vh - 339px)">
        <thead>
          <tr>
            <th v-for="header in headers" :class="header.class">
              <div v-if="header.value == 'status'" @click="sortStatus(asc, 1)" style="cursor: pointer">
                {{ header.text }}
              </div>
              <div v-else>{{ header.text }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="dataTable.length > 0 && !isLoading">
            <tr v-for="(item, i) in dataTable">
              <td class="text-center vertical-middle">{{ i + 1 }}</td>
              <td class="vertical-middle">
                {{ item.rateCategoryCode }}
              </td>
              <td class="vertical-middle font-weight-bold">
                <a class="app-link" href="javascript:;" @click="editItem(item)"
                  v-if="item.i18ns.filter((x) => x.lang == defaultI18n).length > 0">
                  {{ item.i18ns.find((x) => x.lang == defaultI18n).name }}
                </a>
                <a class="app-link" href="javascript:;" @click="editItem(item)" v-else>
                  {{ item.nameVi }}
                </a>
              </td>
              <td class="text-center vertical-middle">
                <div class="d-flex justify-center">
                  <v-switch v-model="item.status" class="item-switch m-0 p-0" @change="changeStatus(item)"></v-switch>
                </div>
              </td>
              <td class="text-center vertical-middle">
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                      color="primary" outlined>
                      <v-icon size="15"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  {{ $t("EDIT") }}
                </v-tooltip>
                <v-tooltip top transition="slide-y-reverse-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small v-bind="attrs"
                      v-on="on" class="rounded-sm" outlined>
                      <v-icon size="15"> delete </v-icon>
                    </v-btn>
                  </template>
                  {{ $t("DELETE") }}
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-else-if="!isLoading">
            <tr>
              <td colspan="7" class="text-center vertical-middle font-weight-bold font-italic" style="color: red">
                {{ $t("NO_DATA") }}
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
      <b-row>
        <b-col md="4" class="d-flex align-center">
        </b-col>

        <b-col md="4" class="text-center">
          <a v-if="dataTable.length < paging.total" class="text-primary" @click="showMore()">{{
            $t('SHOW_MORE')
          }}
            <i class="icon-keyboard_double_arrow_down"> </i>
          </a>
        </b-col>
        <b-col md="4" class="text-right">
          <span v-if="paging" class="pr-3">{{ $tc('TO_PAGE', dataTable.length) }} | {{ $t("TOTAL") }}: {{ paging.total }}
            {{ $t("_SALE_PACKAGE.RATE_CATEGORY") }}</span>
        </b-col>
      </b-row>
      <delete-dialog @deleteItem="deleteItem" :maxWidth="325" ref="deleteDialogComponent">
        <span slot="title">{{ $t("CONFIRM_DELETE_RATE_CATEGORY") }}?</span>
      </delete-dialog>
      <confirm-dialog @deleteItem="changeStatusItem" @cancelDelete="cancelDelete" :maxWidth="450" :persistent="true"
        ref="changeStatusDialogComponent">
        <span slot="title">{{ $t("CONFIRM_CHANGE_STATUS_SALE_PACKAGE") }}</span>
      </confirm-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { ChainCategoryService } from "@/_services/ChainManage/category.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";

export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
  },
  data() {
    return {
      isLoading: false,
      isLoadingPopup: false,
      sysLang: this.$i18n.locale,
      dialog: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center",
        },
        {
          text: this.$t("_CATEGORY.CODE"),
          value: "rateCategoryCode",
          width: "10%",
        },
        {
          text: this.$t("_CATEGORY.NAME"),
          value: "nameVi",
        },
        {
          text: this.$t("STATUS"),
          value: "status",
          class: "text-center",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center",
        },
      ],
      data: [],
      dataTable: [],
      selected: [],
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
      },
      orderBy: "active",
      asc: false,
      meals: [],
    };
  },
  created() {
    this.listStatus = [
      { id: "all", value: this.$t("ALL")},
      {
        id: true,
        value: this.$t("ACTIVE"),
      },
      {
        id: false,
        value: this.$t("DEACTIVE"),
      },
    ];
    this.initialize();
  },
  mounted() { },
  watch: {},
  methods: {
    initialize() {
      this.getAll(true);
    },
    showMore() {
      if (this.paging.total - this.dataTable.length > 0) {
        this.paging.offset += this.paging.limit;
        this.getAll();
      }

    },
    getAll(isSearching) {
      if (isSearching) {
        this.paging.offset = 0;
        this.data = [];
        this.dataTable = [];
      }
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;
      this.isLoading = true;
      ChainCategoryService
        .getRateCategoryList(body)
        .then((res) => {
          this.data = this.data.concat(res.data);
          this.dataTable = this.dataTable.concat(res.data);
          this.paging.total = res.total;
        })
        .finally(() => (this.isLoading = false));
    },
    sortStatus(asc, isSearching) {
      if (asc) {
        this.asc = false;
      } else {
        this.asc = true;
      }
      this.getAll(isSearching);
    },
    addNew() {
      this.$router.push({ name: "ChainRateCategoryDetail", params: { id: 0 } });
    },
    changeStatus(item) {
      ChainCategoryService.updateStatus(item.id).then((res) => {
        if (res.responseCode !== 0) {
          item.status = !item.status;
        }
        _alert(res, this.$t(res.data), true);
      });
    },
    editItem(item) {
      this.$router.push({ name: "ChainRateCategoryDetail", params: { id: item.id } });
    },
    cancelDelete(item) {
      item.status = !item.status;
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      const indexTable = this.dataTable.indexOf(item);
      ChainCategoryService.remove(item.id).then((res) => {
        if (res.responseCode == 0) {
          this.selected.splice(this.selected.indexOf(item), 1);
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeStatusItem(item) {
      this.isLoadingPopup = true;
      this.changeStatus(item);
    },
    formatDate: _formatDate,
    _formatCurrency: _formatCurrency,
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
  },
};
</script>
